import { PropertyCategoryPage } from "apps/propertySelection/propertyCategory/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(PropertyCategoryPage, "PropertyCategoryPage");
